import { HttpClient } from '@angular/common/http';
import { Queue } from '@sentry/indexeddb-client';
import { Observable } from 'rxjs';
import { first, switchMap } from 'rxjs/operators';
import { v4 as uuidv4 } from 'uuid';
import {
  networkDatabaseName,
  networkObjectStoreName,
  NetworkService,
} from './network.service';

export interface RequestDbItem {
  id: string;
  request: string;
}

export interface DeferredRequest {
  type: 'POST' | 'PUT';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  body: any;
  url: string;
}

export const offlineClient = (
  httpClient: HttpClient
): ((
  request: DeferredRequest,
  networkService: NetworkService
// eslint-disable-next-line @typescript-eslint/no-explicit-any
) => Observable<any>) => {
  function deferRequestWhenOffline(
    deferredRequest: DeferredRequest,
    networkService: NetworkService
  ) {
    return networkService.isOffline$.pipe(
      first(),
      switchMap((isOffline) => {
        if (isOffline) {
          const requestQueue = new Queue<RequestDbItem>({
            databaseName: networkDatabaseName,
            objectStoreName: networkObjectStoreName,
          });

          const item: RequestDbItem = {
            id: uuidv4(),
            request: JSON.stringify(deferredRequest),
          };

          return requestQueue.enqueue(item);
        }

        if (deferredRequest.type === 'PUT') {
          return httpClient.put(deferredRequest.url, deferredRequest.body);
        }
        if (deferredRequest.type === 'POST') {
          return httpClient.post(deferredRequest.url, deferredRequest.body);
        }

        throw new Error();
      })
    );
  }

  return deferRequestWhenOffline;
};
